// extracted by extract-css-chunks-webpack-plugin
module.exports = {"product":"product_3FcbL"};